import tw, { styled } from "twin.macro";

export const StyledGradient = styled.div<{ $isGoodReview: boolean }>`
  ${tw`flex flex-col items-center text-center gap-1 px-m p-l`}

  ${({ $isGoodReview }) => ($isGoodReview ? tw`bg-cta-secondary-default` : tw`bg-neutral`)};
`;

export const StyledCodeCopy = styled.div`
  ${tw`border-dashed border-primaryV2-50 border-4 rounded-md text-center w-full p-sm bg-neutral-20 mt-s cursor-pointer hover:bg-neutral-30 transition-colors`}
`;
